import { DefaultCachingNumberFormatter as NumberFormatter } from '@square/dashboard-translations/utils/field-kit/default-caching-number-formatter';

// Given an amount of cents, converts to the form '0,00 €' - currently used in FR and ES
export default class DecimalEuroCurrencyCentFormatter extends NumberFormatter {
  constructor() {
    super();
    this.setNumberStyle(NumberFormatter.Style.CURRENCY).setMaximumFractionDigits(2).setMinimumFractionDigits(2).setPositivePrefix('').setPositiveSuffix(' €').setNegativePrefix('-').setNegativeSuffix(' €').setDecimalSeparator(',');
  }
  format(cents) {
    return super.format(cents / 100);
  }
}